import React from 'react';

import { getMinutes } from 'date-fns';

type Props = {
  tick: {
    id: string;
    value: number;
    percent: number;
  };
  count: number;
  format: any;
};

const TimelineTimeTick = ({ count, format, tick }: Props) => {
  const isFullHour = !getMinutes(tick.value);

  const tickLabelStyle = {
    marginLeft: `${-(100 / count) / 2}%`,
    width: `${100 / count}%`,
    left: `${tick.percent}%`,
  };

  return (
    <>
      <div
        className={`react_time_range__tick_marker${isFullHour ? '__large' : ''}`}
        style={{ left: `${tick.percent}%` }}
      />
      {isFullHour && (
        <div className="react_time_range__tick_label" style={tickLabelStyle}>
          {format(tick.value)}
        </div>
      )}
    </>
  );
};

export default TimelineTimeTick;
